import { render, staticRenderFns } from "./BaseFiltersBar.vue?vue&type=template&id=030c81e1&"
import script from "./BaseFiltersBar.vue?vue&type=script&lang=js&"
export * from "./BaseFiltersBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports